import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ClientLinksQuery, ClientLinksQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ClientLinksQuery)
@Wrapper(ClientLinksQueryHandlerBase)
export class ClientLinksQueryHandler {
    public constructor(http: Http) {}
}
